
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diwalidetox",
      function () {
        return require("private-next-pages/diwalidetox/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/diwalidetox"])
      });
    }
  